import { updateObject } from '../../utils/utility';

const initialState = {
    list: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listRefreshed: false,
    apiFetchError: false,
    bulkUploadTaskComplete: false,
    bulkUploadTaskInProgress: false,
    bulkUploadTaskError: false,
    bulkUploadTemplateDownloadError: false
};

const setBulkUploadList = (state = initialState, action) => {
        const { bulkUploadedPOFilesList, totalElements, pageNumber, totalPages } = action.payload;
        return updateObject(state, { 
            list: bulkUploadedPOFilesList,
            totalElements: totalElements,
            pageNumber: pageNumber,
            totalPages: totalPages,
            listRefreshed: true,
            apiFetchError: false
        }
    );
};

const setListRefreshed = (state = initialState, action) => {
    return updateObject(state, {
        listRefreshed : action.data
    });
};

const setAPIFetchError = (state = initialState, action) => {
    return updateObject(state, {
        apiFetchError : action.data,
        listRefreshed : action.data
    });
};

const setBulkUploadComplete = (state = initialState, action) => {
    return updateObject(state, {
        bulkUploadTaskComplete : true,
        bulkUploadTaskInProgress: false,
        bulkUploadTaskError: false
    });
};

const resetBulkUploadTask = (state = initialState, action) => {
    return updateObject(state, {
        bulkUploadTaskComplete : false,
        bulkUploadTaskInProgress: false,
        bulkUploadTaskError: false,
        bulkUploadTemplateDownloadError: false
    });
};

const setBulkUploadError = (state = initialState, action) => {
    return updateObject(state, {
        bulkUploadTaskComplete : true,
        bulkUploadTaskInProgress: false,
        bulkUploadTaskError: true
    });
};

const setBulkUploadInProgress = (state = initialState, action) => {
    return updateObject(state, {
        bulkUploadTaskInProgress: true
    });
};

const setBulkUploadTemplateDownloadError = (state = initialState, action) => {
    return updateObject(state, {
        bulkUploadTemplateDownloadError: action.data
    });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_PO_BULK_UPLOAD_LIST") {
        return setBulkUploadList(state, action);
    }
    if (action.type === "SET_PO_LIST_REFRESHED") {
        return setListRefreshed(state, action);
    }
    if (action.type === "SET_PO_API_FETCH_ERROR") {
        return setAPIFetchError(state, action);
    }
    if (action.type === "SET_PO_BULK_UPLOAD_IN_PROGRESS") {
        return setBulkUploadInProgress(state, action);
    }
    if (action.type === "SET_PO_BULK_UPLOAD_COMPLETE") {
        return setBulkUploadComplete(state, action);
    }
    if (action.type === "SET_PO_BULK_UPLOAD_ERROR") {
        return setBulkUploadError(state, action);
    }
    if (action.type === "RESET_PO_BULK_UPLOAD_TASK") {
        return resetBulkUploadTask(state, action);
    }
    if (action.type === "SET_PO_BULK_UPLOAD_TEMPLATE_DOWNLOAD_ERROR") {
        return setBulkUploadTemplateDownloadError(state, action);
    }
    return state;
}

export default reducer;
